export interface VisiblePlanInput {
  slug: string;
  comingSoon?: boolean | null;
}

/**
 * Filters the plan list returned by the GraphQL query for the current viewer.
 *
 * Hides:
 *   - CHEFS_SPECIAL — always (still under development; not exposed even if seeded)
 *   - TWOHDSC      — always (internal partner-only plan; assignable exclusively
 *                    by ADMIN via `adminAssignPlan`. Server-side enforcement
 *                    rejects `subscribeToPlan({ plan: "TWOHDSC" })` regardless
 *                    of what the UI shows. The previous URL magic-key gate
 *                    was hardcoded in the JS bundle and provided no security)
 *
 * Keeps:
 *   - comingSoon plans — UI shows them but disables the "Assinar" button.
 */
export const filterVisiblePlans = <T extends VisiblePlanInput>({ plans }: { plans: readonly T[]; queryString?: string }): T[] => {
  return plans.filter((plan) => {
    if (plan.slug === 'CHEFS_SPECIAL') return false;
    if (plan.slug === 'TWOHDSC') return false;
    return true;
  });
};
